// import React, { useState, useEffect } from 'react';
// import { ref, onValue } from 'firebase/database';
// import { db } from '../firebase';
// import { useNavigate } from 'react-router-dom';
// import ProductGrid from './ProductGrid';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import styled, { keyframes } from 'styled-components';
// import { 
//   FaSun, 
//   FaShieldAlt, 
//   FaEye, 
//   FaGem, 
//   FaLeaf, 
//   FaUsers, 
//   FaStar,
//   FaArrowRight,
//   FaSearch,
//   FaFilter
// } from 'react-icons/fa';
// import { HiOutlineSparkles, HiOutlineFire } from 'react-icons/hi';
// import { BsSunglasses, BsStarFill } from 'react-icons/bs';

// // Enhanced Keyframe Animations
// const slideInFromTop = keyframes`
//   from {
//     transform: translateY(-50px);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(0);
//     opacity: 1;
//   }
// `;

// const slideInFromLeft = keyframes`
//   from {
//     transform: translateX(-50px);
//     opacity: 0;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// `;

// const slideInFromRight = keyframes`
//   from {
//     transform: translateX(50px);
//     opacity: 0;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// `;

// const fadeInUp = keyframes`
//   from {
//     transform: translateY(30px);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(0);
//     opacity: 1;
//   }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-12px); }
// `;

// const spin = keyframes`
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// `;

// const sparkle = keyframes`
//   0%, 100% { opacity: 0; transform: scale(0.8) rotate(0deg); }
//   50% { opacity: 1; transform: scale(1) rotate(180deg); }
// `;

// const wavingHand = keyframes`
//   0%, 100% { transform: rotate(0deg); }
//   25% { transform: rotate(20deg); }
//   75% { transform: rotate(-10deg); }
// `;

// // Enhanced Styled Components
// const PageContainer = styled.div`
//   min-height: 100vh;
//   background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: 
//       radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.05) 0%, transparent 50%),
//       radial-gradient(circle at 80% 20%, rgba(249, 115, 22, 0.05) 0%, transparent 50%),
//       radial-gradient(circle at 40% 80%, rgba(168, 85, 247, 0.05) 0%, transparent 50%);
//     animation: ${floatAnimation} 20s ease-in-out infinite;
//   }
// `;

// const MainContent = styled.div`
//   position: relative;
//   z-index: 1;
//   max-width: 1600px;
//   margin: 0 auto;
//   padding: 2rem;
  
//   @media (max-width: 768px) {
//     padding: 1rem;
//   }
// `;

// const HeroSection = styled.div`
//   text-align: center;
//   margin-bottom: 4rem;
//   padding: 4rem 2rem;
//   background: rgba(255, 255, 255, 0.7);
//   border-radius: 32px;
//   backdrop-filter: blur(20px);
//   box-shadow: 
//     0 25px 50px rgba(0, 0, 0, 0.1),
//     0 0 0 1px rgba(255, 255, 255, 0.2);
//   animation: ${slideInFromTop} 1s ease-out;
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
//     animation: ${shimmer} 3s ease-in-out infinite;
//   }
  
//   @media (max-width: 768px) {
//     padding: 3rem 1.5rem;
//     margin-bottom: 3rem;
//   }
// `;

// const HeroTitle = styled.h1`
//   font-size: 4rem;
//   font-weight: 900;
//   margin: 0 0 1.5rem 0;
//   line-height: 1.1;
//   letter-spacing: -0.02em;
//   position: relative;
//   z-index: 2;
  
//   .sunglasses-word {
//     background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//   }
  
//   .collection-word {
//     background: linear-gradient(135deg, #3b82f6 0%, #f97316 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     position: relative;
    
//     &:after {
//       content: '😎';
//       position: absolute;
//       top: -15px;
//       right: -50px;
//       font-size: 2.5rem;
//       animation: ${floatAnimation} 3s ease-in-out infinite;
//     }
//   }
  
//   @media (max-width: 768px) {
//     font-size: 2.8rem;
    
//     .collection-word:after {
//       right: -35px;
//       font-size: 2rem;
//     }
//   }
  
//   @media (max-width: 480px) {
//     font-size: 2.2rem;
    
//     .collection-word:after {
//       right: -30px;
//       font-size: 1.5rem;
//     }
//   }
// `;

// const HeroSubtitle = styled.p`
//   font-size: 1.3rem;
//   color: #64748b;
//   max-width: 800px;
//   margin: 0 auto 2rem auto;
//   line-height: 1.7;
//   font-weight: 400;
//   position: relative;
//   z-index: 2;
  
//   @media (max-width: 768px) {
//     font-size: 1.1rem;
//   }
// `;

// const FeatureGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
//   gap: 1.5rem;
//   margin-top: 3rem;
//   animation: ${fadeInUp} 1s ease-out 0.5s both;
  
//   @media (max-width: 768px) {
//     grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
//     gap: 1rem;
//   }
// `;

// const FeatureCard = styled.div`
//   background: rgba(255, 255, 255, 0.8);
//   padding: 2rem 1.5rem;
//   border-radius: 20px;
//   text-align: center;
//   transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
//   border: 1px solid rgba(255, 255, 255, 0.2);
//   backdrop-filter: blur(10px);
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(249, 115, 22, 0.05) 100%);
//     opacity: 0;
//     transition: opacity 0.3s ease;
//   }
  
//   &:hover {
//     transform: translateY(-8px) scale(1.02);
//     box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
    
//     &:before {
//       opacity: 1;
//     }
//   }
  
//   .icon {
//     font-size: 2.5rem;
//     margin-bottom: 1rem;
//     background: linear-gradient(135deg, #3b82f6 0%, #f97316 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     position: relative;
//     z-index: 2;
//   }
  
//   .title {
//     font-size: 1.1rem;
//     font-weight: 700;
//     color: #1e293b;
//     margin-bottom: 0.5rem;
//     position: relative;
//     z-index: 2;
//   }
  
//   .description {
//     font-size: 0.9rem;
//     color: #64748b;
//     line-height: 1.5;
//     position: relative;
//     z-index: 2;
//   }
  
//   @media (max-width: 768px) {
//     padding: 1.5rem 1rem;
    
//     .icon {
//       font-size: 2rem;
//     }
    
//     .title {
//       font-size: 1rem;
//     }
    
//     .description {
//       font-size: 0.85rem;
//     }
//   }
// `;

// const ProductsSection = styled.div`
//   animation: ${fadeInUp} 1s ease-out 0.7s both;
// `;

// const SectionHeader = styled.div`
//   text-align: center;
//   margin-bottom: 3rem;
  
//   h2 {
//     font-size: 2.5rem;
//     font-weight: 800;
//     background: linear-gradient(135deg, #1e293b 0%, #3b82f6 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     margin: 0 0 1rem 0;
//     position: relative;
    
//     &:after {
//       content: '✨';
//       position: absolute;
//       top: -10px;
//       right: -40px;
//       font-size: 1.8rem;
//       animation: ${sparkle} 2s ease-in-out infinite;
//     }
    
//     @media (max-width: 768px) {
//       font-size: 2rem;
      
//       &:after {
//         right: -30px;
//         font-size: 1.5rem;
//       }
//     }
//   }
  
//   p {
//     font-size: 1.1rem;
//     color: #64748b;
//     max-width: 600px;
//     margin: 0 auto;
//     line-height: 1.6;
//   }
// `;

// const FilterControls = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 1rem;
//   margin-bottom: 3rem;
//   animation: ${slideInFromLeft} 1s ease-out 0.9s both;
  
//   @media (max-width: 768px) {
//     flex-direction: column;
//     align-items: center;
//   }
// `;

// const ControlButton = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 0.75rem;
//   padding: 1rem 2rem;
//   background: rgba(255, 255, 255, 0.9);
//   border: 2px solid rgba(59, 130, 246, 0.2);
//   border-radius: 50px;
//   color: #1e293b;
//   font-weight: 600;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   backdrop-filter: blur(10px);
//   box-shadow: 0 8px 20px rgba(59, 130, 246, 0.1);
  
//   &:hover {
//     background: rgba(59, 130, 246, 0.1);
//     border-color: rgba(59, 130, 246, 0.4);
//     transform: translateY(-2px);
//     box-shadow: 0 12px 30px rgba(59, 130, 246, 0.2);
//   }
  
//   svg {
//     color: #3b82f6;
//   }
  
//   @media (max-width: 768px) {
//     padding: 0.875rem 1.5rem;
//     font-size: 0.9rem;
//   }
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 5rem 2rem;
//   background: rgba(255, 255, 255, 0.8);
//   border-radius: 32px;
//   backdrop-filter: blur(20px);
//   box-shadow: 
//     0 25px 50px rgba(0, 0, 0, 0.1),
//     0 0 0 1px rgba(255, 255, 255, 0.2);
//   max-width: 900px;
//   margin: 0 auto;
//   animation: ${fadeInUp} 1s ease-out;
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
//     animation: ${shimmer} 3s ease-in-out infinite;
//   }
  
//   .icon {
//     font-size: 5rem;
//     margin-bottom: 2rem;
//     animation: ${floatAnimation} 3s ease-in-out infinite;
//     position: relative;
//     z-index: 2;
//   }
  
//   h3 {
//     font-size: 2.2rem;
//     font-weight: 700;
//     color: #1e293b;
//     margin-bottom: 1rem;
//     position: relative;
//     z-index: 2;
//   }
  
//   p {
//     font-size: 1.2rem;
//     color: #64748b;
//     max-width: 600px;
//     margin: 0 auto 2.5rem auto;
//     line-height: 1.6;
//     position: relative;
//     z-index: 2;
//   }
  
//   @media (max-width: 768px) {
//     padding: 4rem 1.5rem;
    
//     .icon {
//       font-size: 4rem;
//     }
    
//     h3 {
//       font-size: 1.8rem;
//     }
    
//     p {
//       font-size: 1.1rem;
//     }
//   }
// `;

// const ExploreButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.75rem;
//   padding: 1.25rem 2.5rem;
//   background: linear-gradient(135deg, #3b82f6 0%, #f97316 100%);
//   color: white;
//   border: none;
//   border-radius: 50px;
//   font-weight: 700;
//   font-size: 1.1rem;
//   cursor: pointer;
//   transition: all 0.4s ease;
//   box-shadow: 0 10px 25px rgba(59, 130, 246, 0.4);
//   position: relative;
//   overflow: hidden;
//   z-index: 2;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
//     transition: left 0.5s ease;
//   }
  
//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0 15px 35px rgba(59, 130, 246, 0.5);
    
//     &:before {
//       left: 100%;
//     }
    
//     svg {
//       transform: translateX(4px);
//     }
//   }
  
//   svg {
//     transition: transform 0.3s ease;
//   }
  
//   @media (max-width: 768px) {
//     padding: 1rem 2rem;
//     font-size: 1rem;
//   }
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   min-height: 70vh;
//   gap: 2rem;
//   color: #1e293b;
  
//   .spinner {
//     width: 80px;
//     height: 80px;
//     border: 6px solid rgba(59, 130, 246, 0.3);
//     border-top: 6px solid #3b82f6;
//     border-radius: 50%;
//     animation: ${spin} 1s linear infinite;
//   }
  
//   .loading-text {
//     font-size: 1.3rem;
//     font-weight: 600;
//     animation: ${pulse} 2s ease-in-out infinite;
//   }
  
//   .loading-subtitle {
//     font-size: 1rem;
//     color: #64748b;
//     text-align: center;
//     max-width: 400px;
//   }
// `;

// const WaveEmoji = styled.span`
//   display: inline-block;
//   animation: ${wavingHand} 2s ease-in-out infinite;
// `;

// const SunglassesPage = () => {
//   const [sunglasses, setSunglasses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filteredSunglasses, setFilteredSunglasses] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const productsRef = ref(db, 'Watch/admin/products');
//     const unsubscribe = onValue(productsRef, (snapshot) => {
//       const productsData = snapshot.val();
//       if (productsData) {
//         const sunglassesList = Object.entries(productsData)
//           .map(([id, data]) => ({ id, ...data }))
//           .filter(product => product.category === 'sunglasses');
//         setSunglasses(sunglassesList);
//         setFilteredSunglasses(sunglassesList);
//       } else {
//         setSunglasses([]);
//         setFilteredSunglasses([]);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (searchTerm) {
//       const filtered = sunglasses.filter(product =>
//         product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         product.brand?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         product.description?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredSunglasses(filtered);
//     } else {
//       setFilteredSunglasses(sunglasses);
//     }
//   }, [searchTerm, sunglasses]);

//   const features = [
//     {
//       icon: <FaSun />,
//       title: "UV Protection",
//       description: "100% UV400 protection against harmful rays"
//     },
//     {
//       icon: <FaShieldAlt />,
//       title: "Durable Build",
//       description: "Premium materials for long-lasting wear"
//     },
//     {
//       icon: <FaEye />,
//       title: "Clear Vision",
//       description: "Crystal clear lenses for optimal visibility"
//     },
//     {
//       icon: <FaGem />,
//       title: "Luxury Design",
//       description: "Fashionable frames for every style"
//     }
//   ];

//   if (loading) {
//     return (
//       <PageContainer>
//         <Navbar />
//         <MainContent>
//           <LoadingContainer>
//             <div className="spinner"></div>
//             <div className="loading-text">
//               Loading Amazing Shades <WaveEmoji>😎</WaveEmoji>
//             </div>
//             <div className="loading-subtitle">
//               Preparing our premium collection of sunglasses just for you...
//             </div>
//           </LoadingContainer>
//         </MainContent>
//       </PageContainer>
//     );
//   }

//   return (
//     <PageContainer>
//       <Navbar />
//       <MainContent>
//         <HeroSection>
//           <HeroTitle>
//             <span className="sunglasses-word">SUNGLASSES</span>{' '}
//             <span className="collection-word">COLLECTION</span>
//           </HeroTitle>
//           <HeroSubtitle>
//             Discover premium eyewear that perfectly combines style, comfort, and UV protection.
//             Our curated collection features the latest trends and timeless classics.
//           </HeroSubtitle>
          
//           <FeatureGrid>
//             {features.map((feature, index) => (
//               <FeatureCard key={index}>
//                 <div className="icon">{feature.icon}</div>
//                 <div className="title">{feature.title}</div>
//                 <div className="description">{feature.description}</div>
//               </FeatureCard>
//             ))}
//           </FeatureGrid>
//         </HeroSection>

//         <ProductsSection>
//           {sunglasses.length === 0 ? (
//             <EmptyState>
//               <div className="icon">
//                 <BsSunglasses />
//               </div>
//               <h3>Collection Coming Soon</h3>
//               <p>
//                 We're curating an amazing collection of premium sunglasses just for you. 
//                 Check back soon to discover styles that will make you shine! <WaveEmoji>✨</WaveEmoji>
//               </p>
//               <ExploreButton onClick={() => navigate('/products')}>
//                 <HiOutlineSparkles />
//                 Explore Other Collections
//                 <FaArrowRight />
//               </ExploreButton>
//             </EmptyState>
//           ) : (
//             <>
//               <SectionHeader>
//                 <h2>Premium Sunglasses</h2>
//                 <p>
//                   Browse our handpicked selection of {sunglasses.length} premium sunglasses
//                 </p>
//               </SectionHeader>

//               <FilterControls>
//                 <ControlButton onClick={() => setSearchTerm('')}>
//                   <FaSearch />
//                   All Styles ({sunglasses.length})
//                 </ControlButton>
//                 <ControlButton onClick={() => alert('Filter feature coming soon!')}>
//                   <FaFilter />
//                   Filter & Sort
//                 </ControlButton>
//               </FilterControls>

//               <ProductGrid
//                 products={filteredSunglasses}
//                 loading={false}
//                 loadingCount={12}
//                 showHeader={false}
//                 gridConfig={{
//                   columns: {
//                     mobile: 'repeat(auto-fit, minmax(300px, 1fr))',
//                     tablet: 'repeat(auto-fit, minmax(340px, 1fr))',
//                     desktop: 'repeat(auto-fit, minmax(380px, 1fr))'
//                   },
//                   gap: {
//                     mobile: '20px',
//                     tablet: '28px',
//                     desktop: '32px'
//                   },
//                   padding: {
//                     mobile: '16px',
//                     tablet: '24px',
//                     desktop: '32px'
//                   }
//                 }}
//                 cardStyle={{
//                   background: 'rgba(255, 255, 255, 0.95)',
//                   borderRadius: '24px',
//                   boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
//                   backdropFilter: 'blur(20px)',
//                   border: '1px solid rgba(255, 255, 255, 0.2)'
//                 }}
//               />
//             </>
//           )}
//         </ProductsSection>
//       </MainContent>
//       <Footer />
//     </PageContainer>
//   );
// };

// export default SunglassesPage;


import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import ProductGrid from './ProductGrid';
import Navbar from './Navbar';
import Footer from './Footer';
import { FaFilter, FaTimes, FaSearch } from 'react-icons/fa';
import { BsChevronDown, BsSunglasses } from 'react-icons/bs';

const SunglassesPage = () => {
  const [sunglasses, setSunglasses] = useState([]);
  const [filteredSunglasses, setFilteredSunglasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();

  // Filter states
  const [searchTerm, setSearchTerm] = useState('');
  const [priceRange, setPriceRange] = useState([0, 20000]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedFrameTypes, setSelectedFrameTypes] = useState([]);
  const [selectedLensColors, setSelectedLensColors] = useState([]);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedFrameColors, setSelectedFrameColors] = useState([]);
  const [sortOption, setSortOption] = useState('featured');

  // Available filter options
  const [allBrands, setAllBrands] = useState([]);
  const [allGenders, setAllGenders] = useState([]);
  const [allFrameTypes, setAllFrameTypes] = useState([]);
  const [allLensColors, setAllLensColors] = useState([]);
  const [allMaterials, setAllMaterials] = useState([]);
  const [allFrameColors, setAllFrameColors] = useState([]);

  useEffect(() => {
    const productsRef = ref(db, 'Watch/admin/products');
    const unsubscribe = onValue(productsRef, (snapshot) => {
      const productsData = snapshot.val();
      if (productsData) {
        const sunglassesList = Object.entries(productsData)
          .map(([id, data]) => ({ id, ...data }))
          .filter(product => product.category === 'sunglasses');
        
        setSunglasses(sunglassesList);

        // Extract unique filter options
        const uniqueBrands = [...new Set(sunglassesList.map(s => s.brand).filter(Boolean))];
        setAllBrands(uniqueBrands);

        const uniqueGenders = [...new Set(
          sunglassesList
            .map(s => {
              const gender = s.specifications?.gender;
              return gender && typeof gender === 'string' ? gender : null;
            })
            .filter(Boolean)
        )];
        setAllGenders(uniqueGenders);

        const uniqueFrameTypes = [...new Set(
          sunglassesList
            .map(s => {
              const frameType = s.specifications?.frameType || s.specifications?.frameShape;
              return frameType && typeof frameType === 'string' ? frameType : null;
            })
            .filter(Boolean)
        )];
        setAllFrameTypes(uniqueFrameTypes);

        const uniqueLensColors = [...new Set(
          sunglassesList
            .map(s => {
              const lensColor = s.specifications?.lensColor || s.specifications?.color;
              return lensColor && typeof lensColor === 'string' ? lensColor : null;
            })
            .filter(Boolean)
        )];
        setAllLensColors(uniqueLensColors);

        const uniqueMaterials = [...new Set(
          sunglassesList.flatMap(s => {
            const materials = [];
            if (Array.isArray(s.specifications?.materials)) {
              materials.push(...s.specifications.materials.filter(m => m && typeof m === 'string'));
            } else if (s.specifications?.material && typeof s.specifications.material === 'string') {
              materials.push(s.specifications.material);
            }
            return materials;
          })
        )];
        setAllMaterials(uniqueMaterials);

        // Extract unique frame colors - IMPROVED VERSION
        const uniqueFrameColors = [...new Set(
          sunglassesList.flatMap(s => {
            const colors = [];
            
            // Check for frameColors array
            if (Array.isArray(s.specifications?.frameColors)) {
              colors.push(...s.specifications.frameColors.filter(c => c && typeof c === 'string'));
            }
            // Check for frameColor string
            else if (s.specifications?.frameColor && typeof s.specifications.frameColor === 'string') {
              colors.push(s.specifications.frameColor);
            }
            // Also check for color field
            else if (s.specifications?.color && typeof s.specifications.color === 'string') {
              colors.push(s.specifications.color);
            }
            // Check for colors array
            else if (Array.isArray(s.specifications?.colors)) {
              colors.push(...s.specifications.colors.filter(c => c && typeof c === 'string'));
            }
            
            return colors.map(c => c.toLowerCase().trim());
          }).filter(Boolean)
        )];
        setAllFrameColors(uniqueFrameColors);

        console.log('Extracted Frame Colors:', uniqueFrameColors); // Debug log
      } else {
        setSunglasses([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Apply filters
  useEffect(() => {
    let result = [...sunglasses];

    // Search filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter(s =>
        s.name.toLowerCase().includes(term) ||
        (s.brand && s.brand.toLowerCase().includes(term)) ||
        (s.description && s.description.toLowerCase().includes(term))
      );
    }

    // Price filter
    result = result.filter(s => s.price >= priceRange[0] && s.price <= priceRange[1]);

    // Brand filter
    if (selectedBrands.length > 0) {
      result = result.filter(s => s.brand && selectedBrands.includes(s.brand));
    }

    // Gender filter
    if (selectedGenders.length > 0) {
      result = result.filter(s => {
        const gender = s.specifications?.gender;
        return gender && typeof gender === 'string' && selectedGenders.includes(gender);
      });
    }

    // Frame type filter
    if (selectedFrameTypes.length > 0) {
      result = result.filter(s => {
        const frameType = s.specifications?.frameType || s.specifications?.frameShape;
        return frameType && typeof frameType === 'string' && selectedFrameTypes.includes(frameType);
      });
    }

    // Lens color filter
    if (selectedLensColors.length > 0) {
      result = result.filter(s => {
        const lensColor = s.specifications?.lensColor || s.specifications?.color;
        return lensColor && typeof lensColor === 'string' && selectedLensColors.includes(lensColor);
      });
    }

    // Material filter
    if (selectedMaterials.length > 0) {
      result = result.filter(s => {
        const productMaterials = [];
        if (Array.isArray(s.specifications?.materials)) {
          productMaterials.push(...s.specifications.materials.filter(m => m && typeof m === 'string'));
        } else if (s.specifications?.material && typeof s.specifications.material === 'string') {
          productMaterials.push(s.specifications.material);
        }
        return productMaterials.some(material => selectedMaterials.includes(material));
      });
    }

    // Frame color filter - IMPROVED VERSION
    if (selectedFrameColors.length > 0) {
      result = result.filter(s => {
        const productFrameColors = [];
        
        // Check for frameColors array
        if (Array.isArray(s.specifications?.frameColors)) {
          productFrameColors.push(...s.specifications.frameColors.filter(c => c && typeof c === 'string').map(c => c.toLowerCase().trim()));
        }
        // Check for frameColor string
        else if (s.specifications?.frameColor && typeof s.specifications.frameColor === 'string') {
          productFrameColors.push(s.specifications.frameColor.toLowerCase().trim());
        }
        // Also check for color field
        else if (s.specifications?.color && typeof s.specifications.color === 'string') {
          productFrameColors.push(s.specifications.color.toLowerCase().trim());
        }
        // Check for colors array
        else if (Array.isArray(s.specifications?.colors)) {
          productFrameColors.push(...s.specifications.colors.filter(c => c && typeof c === 'string').map(c => c.toLowerCase().trim()));
        }
        
        return productFrameColors.some(color => selectedFrameColors.includes(color));
      });
    }

    // Apply sorting
    switch (sortOption) {
      case 'price-low':
        result.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        result.sort((a, b) => b.price - a.price);
        break;
      case 'newest':
        result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case 'featured':
        result.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
        break;
      case 'discount':
        result.sort((a, b) => (b.discount || 0) - (a.discount || 0));
        break;
      default:
        break;
    }

    setFilteredSunglasses(result);
  }, [sunglasses, searchTerm, priceRange, selectedBrands, selectedGenders, selectedFrameTypes, selectedLensColors, selectedMaterials, selectedFrameColors, sortOption]);

  const resetFilters = () => {
    setSearchTerm('');
    setPriceRange([0, 20000]);
    setSelectedBrands([]);
    setSelectedGenders([]);
    setSelectedFrameTypes([]);
    setSelectedLensColors([]);
    setSelectedMaterials([]);
    setSelectedFrameColors([]);
    setSortOption('featured');
  };

  const toggleFilter = (filterArray, setFilterArray, value) => {
    setFilterArray(prev =>
      prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
    );
  };

  // Helper function to get color hex value
  const getColorValue = (colorName) => {
    const colorMap = {
      'black': '#1a1a1a',
      'white': '#ffffff',
      'red': '#e74c3c',
      'blue': '#3498db',
      'green': '#27ae60',
      'yellow': '#f1c40f',
      'silver': '#bdc3c7',
      'gold': '#f39c12',
      'rose gold': '#e8b4b8',
      'navy': '#2c3e50',
      'brown': '#8b4513',
      'gray': '#7f8c8d',
      'grey': '#7f8c8d',
      'pink': '#e91e63',
      'purple': '#9b59b6',
      'orange': '#e67e22',
      'beige': '#f5f5dc',
      'teal': '#1abc9c',
      'burgundy': '#8e2a2a',
      'tan': '#d2b48c',
      'olive': '#808000',
      'maroon': '#800000',
      'tortoise': '#8b4513',
      'transparent': 'rgba(200, 200, 200, 0.3)',
      'clear': 'rgba(220, 220, 220, 0.5)',
      'tortoiseshell': '#8b4513',
      'crystal': 'rgba(230, 230, 250, 0.6)',
      'champagne': '#f7e7ce',
      'bronze': '#cd7f32'
    };
    return colorMap[colorName?.toLowerCase()?.trim()] || '#cccccc';
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f5f2',
        fontFamily: "'Montserrat', sans-serif"
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '3px solid rgba(0,0,0,0.1)',
            borderTop: '3px solid #333',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span style={{
            fontSize: '1.2rem',
            color: '#333',
            letterSpacing: '1px'
          }}>Loading Sunglasses...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div style={{
        background: '#f8f5f2',
        minHeight: '100vh',
        fontFamily: "'Montserrat', sans-serif"
      }}>
        {/* Hero Section */}
        <div style={{
          background: 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          padding: '100px 20px 60px',
          textAlign: 'center',
          marginBottom: '50px'
        }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '300',
            letterSpacing: '2px',
            marginBottom: '20px'
          }}>PREMIUM SUNGLASSES</h1>
          <p style={{
            fontSize: '1.2rem',
            maxWidth: '700px',
            margin: '0 auto',
            fontWeight: '300',
            lineHeight: '1.6'
          }}>
            Discover our exquisite collection of premium sunglasses, where style meets UV protection
          </p>
        </div>

        {/* Filter Controls */}
        {sunglasses.length > 0 && (
          <div style={{
            maxWidth: '1400px',
            margin: '0 auto',
            padding: '0 20px 30px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              marginBottom: '30px'
            }}>
              {/* Search Bar */}
              <div style={{ position: 'relative', maxWidth: '600px' }}>
                <FaSearch style={{
                  position: 'absolute',
                  top: '50%',
                  left: '15px',
                  transform: 'translateY(-50%)',
                  color: '#666',
                  fontSize: '1rem'
                }} />
                <input
                  type="text"
                  placeholder="Search sunglasses by name, brand..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px 15px 12px 45px',
                    border: '1px solid #e0d6cc',
                    borderRadius: '8px',
                    background: 'white',
                    fontSize: '1rem',
                    outline: 'none',
                    transition: 'all 0.3s ease'
                  }}
                />
              </div>

              {/* Controls Row */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                flexWrap: 'wrap'
              }}>
                {/* Sort Select */}
                <div style={{ position: 'relative' }}>
                  <select
                    value={sortOption}
                    onChange={(e) => setSortOption(e.target.value)}
                    style={{
                      padding: '12px 40px 12px 15px',
                      border: '1px solid #e0d6cc',
                      borderRadius: '8px',
                      background: 'white',
                      fontSize: '1rem',
                      appearance: 'none',
                      outline: 'none',
                      cursor: 'pointer',
                      minWidth: '200px'
                    }}
                  >
                    <option value="featured">✨ Featured</option>
                    <option value="price-low">💰 Price: Low to High</option>
                    <option value="price-high">💎 Price: High to Low</option>
                    <option value="newest">🆕 Newest Arrivals</option>
                    <option value="discount">🔥 Best Discounts</option>
                  </select>
                  <BsChevronDown style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    color: '#666'
                  }} />
                </div>

                {/* Filter Button */}
                <button
                  onClick={() => setShowFilters(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '12px 20px',
                    background: '#333',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <FaFilter /> Filters
                </button>

                {/* Results Count */}
                <span style={{ color: '#666', fontSize: '0.95rem', marginLeft: 'auto' }}>
                  {filteredSunglasses.length} {filteredSunglasses.length === 1 ? 'style' : 'styles'} found
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Filter Panel */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            width: '400px',
            maxWidth: '90%',
            background: 'white',
            boxShadow: '-10px 0 30px rgba(0,0,0,0.1)',
            transform: showFilters ? 'translateX(0)' : 'translateX(100%)',
            transition: 'transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
            zIndex: 1000,
            overflowY: 'auto',
            padding: '30px',
            visibility: showFilters ? 'visible' : 'hidden',
            opacity: showFilters ? '1' : '0'
          }}
        >
          {/* Filter Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '30px',
            paddingBottom: '20px',
            borderBottom: '2px solid #e0d6cc'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '400',
              color: '#333',
              margin: 0
            }}>Filter Sunglasses</h2>
            <button
              onClick={() => setShowFilters(false)}
              style={{
                padding: '10px',
                border: 'none',
                background: '#f5f5f5',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaTimes style={{ fontSize: '1.2rem', color: '#333' }} />
            </button>
          </div>

          {/* Price Range Filter */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{
              fontSize: '1.1rem',
              fontWeight: '500',
              color: '#333',
              marginBottom: '15px'
            }}>💰 Price Range</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="number"
                  value={priceRange[0]}
                  onChange={(e) => setPriceRange([parseInt(e.target.value) || 0, priceRange[1]])}
                  min="0"
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #e0d6cc',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
                <span>to</span>
                <input
                  type="number"
                  value={priceRange[1]}
                  onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value) || 20000])}
                  min={priceRange[0]}
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #e0d6cc',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
              <p style={{ textAlign: 'center', color: '#666', fontSize: '0.95rem', margin: 0 }}>
                ₹{priceRange[0].toLocaleString()} - ₹{priceRange[1].toLocaleString()}
              </p>
            </div>
          </div>

          {/* Brand Filter */}
          {allBrands.length > 0 && (
            <FilterSection
              title="🏷️ Brands"
              options={allBrands}
              selectedOptions={selectedBrands}
              onToggle={(value) => toggleFilter(selectedBrands, setSelectedBrands, value)}
            />
          )}

          {/* Gender Filter */}
          {allGenders.length > 0 && (
            <FilterSection
              title="👤 Gender"
              options={allGenders}
              selectedOptions={selectedGenders}
              onToggle={(value) => toggleFilter(selectedGenders, setSelectedGenders, value)}
            />
          )}

          {/* Frame Type Filter */}
          {allFrameTypes.length > 0 && (
            <FilterSection
              title="🖼️ Frame Type"
              options={allFrameTypes}
              selectedOptions={selectedFrameTypes}
              onToggle={(value) => toggleFilter(selectedFrameTypes, setSelectedFrameTypes, value)}
            />
          )}

          {/* Lens Color Filter */}
          {allLensColors.length > 0 && (
            <FilterSection
              title="🎨 Lens Color"
              options={allLensColors}
              selectedOptions={selectedLensColors}
              onToggle={(value) => toggleFilter(selectedLensColors, setSelectedLensColors, value)}
            />
          )}

          {/* Material Filter */}
          {allMaterials.length > 0 && (
            <FilterSection
              title="🧵 Frame Material"
              options={allMaterials}
              selectedOptions={selectedMaterials}
              onToggle={(value) => toggleFilter(selectedMaterials, setSelectedMaterials, value)}
            />
          )}

          {/* Frame Color Filter - ALWAYS SHOW if sunglasses exist */}
          {sunglasses.length > 0 && (
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{
                fontSize: '1.1rem',
                fontWeight: '500',
                color: '#333',
                marginBottom: '15px'
              }}>🎨 Frame Color</h3>
              {allFrameColors.length > 0 ? (
                <div style={{ 
                  display: 'flex', 
                  flexWrap: 'wrap', 
                  gap: '10px' 
                }}>
                  {allFrameColors.map(color => {
                    const colorValue = getColorValue(color);
                    const isSelected = selectedFrameColors.includes(color);
                    const isLightColor = ['white', 'yellow', 'beige', 'cream', 'ivory', 'silver', 'champagne'].includes(color.toLowerCase()) || colorValue.includes('rgba');
                    
                    return (
                      <div 
                        key={color}
                        onClick={() => toggleFilter(selectedFrameColors, setSelectedFrameColors, color)}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: colorValue,
                          border: isSelected 
                            ? '3px solid #333' 
                            : '2px solid #e0d6cc',
                          cursor: 'pointer',
                          boxShadow: isSelected ? '0 4px 12px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.1)',
                          position: 'relative',
                          transition: 'all 0.3s ease',
                          transform: isSelected ? 'scale(1.1)' : 'scale(1)'
                        }}
                        title={color.charAt(0).toUpperCase() + color.slice(1)}
                      >
                        {isSelected && (
                          <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: isLightColor ? '#333' : 'white',
                            fontSize: '16px',
                            fontWeight: 'bold'
                          }}>
                            ✓
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p style={{ 
                  color: '#999', 
                  fontSize: '0.9rem', 
                  fontStyle: 'italic',
                  margin: 0 
                }}>
                  No color options available
                </p>
              )}
            </div>
          )}

          {/* Reset Button */}
          <button
            onClick={() => {
              resetFilters();
              setShowFilters(false);
            }}
            style={{
              width: '100%',
              padding: '15px',
              background: '#333',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer',
              marginTop: '20px',
              transition: 'all 0.3s ease'
            }}
          >
            🔄 Reset All Filters
          </button>
        </div>

        {/* Backdrop */}
        {showFilters && (
          <div
            onClick={() => setShowFilters(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.5)',
              zIndex: 999
            }}
          />
        )}

        {/* Main Content */}
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 20px 60px'
        }}>
          {/* Sunglasses Grid */}
          {sunglasses.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '80px 20px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🕶️</div>
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '15px',
                color: '#333'
              }}>No Sunglasses Available</h3>
              <p style={{
                color: '#666',
                maxWidth: '500px',
                margin: '0 auto 20px',
                lineHeight: '1.6'
              }}>
                Our sunglasses collection is currently being updated. Please check back soon!
              </p>
            </div>
          ) : filteredSunglasses.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '80px 20px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🔍</div>
              <h3 style={{
                fontSize: '1.5rem',
                marginBottom: '15px',
                color: '#333'
              }}>No Sunglasses Found</h3>
              <p style={{
                color: '#666',
                maxWidth: '500px',
                margin: '0 auto 20px',
                lineHeight: '1.6'
              }}>
                Try adjusting your filters or search term to find what you're looking for.
              </p>
              <button
                onClick={resetFilters}
                style={{
                  padding: '12px 30px',
                  background: '#333',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Reset Filters
              </button>
            </div>
          ) : (
            <ProductGrid
              products={filteredSunglasses}
              loading={loading}
              loadingCount={12}
              showHeader={false}
              gridConfig={{
                columns: {
                  mobile: 'repeat(2, 1fr)',
                  tablet: 'repeat(3, 1fr)',
                  desktop: 'repeat(auto-fit, minmax(350px, 1fr))'
                },
                gap: {
                  mobile: '12px',
                  tablet: '20px',
                  desktop: '30px'
                }
              }}
              cardStyle={{
                background: 'white',
                borderRadius: '8px',
                boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
              }}
            />
          )}
        </div>

        {/* Global styles */}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

// Filter Section Component
const FilterSection = ({ title, options, selectedOptions, onToggle }) => (
  <div style={{ marginBottom: '30px' }}>
    <h3 style={{
      fontSize: '1.1rem',
      fontWeight: '500',
      color: '#333',
      marginBottom: '15px'
    }}>{title}</h3>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxHeight: '200px',
      overflowY: 'auto'
    }}>
      {options.map(option => (
        <label
          key={option}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '6px',
            cursor: 'pointer',
            background: selectedOptions.includes(option) ? '#f5f5f5' : 'transparent',
            transition: 'all 0.3s ease'
          }}
        >
          <input
            type="checkbox"
            checked={selectedOptions.includes(option)}
            onChange={() => onToggle(option)}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer',
              accentColor: '#333'
            }}
          />
          <span style={{ fontSize: '0.95rem', color: '#333' }}>
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </span>
        </label>
      ))}
    </div>
  </div>
);

export default SunglassesPage;
